module.exports = __webpack_public_path__ + "img/TNT.9befc7a7.svg";